import { render, staticRenderFns } from "./ProjectCardFundsGather.vue?vue&type=template&id=1fc2f555"
import script from "./ProjectCardFundsGather.vue?vue&type=script&lang=js"
export * from "./ProjectCardFundsGather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports